module.exports = __webpack_public_path__ + "static/media/humidity.9c6d003f.png";